import React from 'react';
import { Crosshair, Layers, Map as MapIcon, Minus, Plus, Satellite } from 'lucide-react';
import { MAP_STYLE_OPTIONS } from './constants';

const STYLE_ICONS = {
  roadmap: MapIcon,
  satellite: Satellite,
  layers: Layers,
};

export function MapControls({ mapStyle, onMapStyleChange, onLocate, onZoomIn, onZoomOut }) {
  return (
    <>
      <div className='otd-map-controls otd-map-controls--top'>
        {MAP_STYLE_OPTIONS.map((opt) => {
          const Icon = STYLE_ICONS[opt.id] ?? MapIcon;
          return (
            <button
              key={opt.id}
              type='button'
              className={`otd-map-pill ${mapStyle === opt.id ? 'otd-map-pill--active' : ''}`}
              onClick={() => onMapStyleChange(opt.id)}
            >
              <Icon size={12} />
              {opt.label}
            </button>
          );
        })}
      </div>

      <div className='otd-map-controls otd-map-controls--bottom'>
        <button type='button' className='otd-map-fab' onClick={onLocate} aria-label='My location'>
          <Crosshair size={14} />
          <span>My Location</span>
        </button>
        <div className='otd-map-zoom'>
          <button type='button' className='otd-map-zoom__btn' onClick={onZoomIn} aria-label='Zoom in'>
            <Plus size={14} />
          </button>
          <button type='button' className='otd-map-zoom__btn' onClick={onZoomOut} aria-label='Zoom out'>
            <Minus size={14} />
          </button>
        </div>
      </div>
    </>
  );
}
